import api, { handleApiError } from "./api";
import { AxiosError } from "axios";
import { User } from "@/types/auth";

export interface UpdateUserPreferencesRequest {
  email?: string;
  first_name?: string;
  last_name?: string;
  company_name?: string;
}

export const userPreferencesService = {
  update: async (payload: UpdateUserPreferencesRequest): Promise<User> => {
    const { data } = await api.patch<User>("/accounts/me/", payload);
    return data;
  },
};

export const getUserPreferencesErrorMessage = (error: unknown): string => {
  if (error instanceof AxiosError) return handleApiError(error);
  if (error instanceof Error) return error.message;
  return "An unexpected error occurred";
};
